module.exports = __webpack_public_path__ + "img/control_de_calidad_16-9_960.2246d1cb.jpg";